<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/37rvwh/tc-custom/9780544188631.jpg?1705231662957" alt="This image is the cover for the book Everything Vegan, Vegetarian Times"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everything Vegan, Vegetarian Times
      </h1>
      <p class="bookDescription body article font2">
        <b>A diverse and delicious collection of over 250 vegan recipes from the experts at <i>Vegetarian Times</i> magazine.</b><br/><br/> Whether you’re vegan for a day, a week, a lifetime, or even just for lunch hour, you’re always on the lookout for deliciously satisfying animal-free recipes. <i>Vegetarian Times Everything Vegan</i> is the something-for-everyone vegan cookbook with hundreds of tasty, healthful recipes that can woo even omnivores to the possibilities of plant-based eating while wowing committed vegans and vegetarians.<br/><br/> Beautifully illustrated and accompanied by a thoughtful and informative foreword by Neal D. Barnard, MD, <i>Vegetarian Times Everything Vegan</i> is a must-have resource for anyone who lives vegan, loves cooking, or is looking for healthy meal ideas with proven weight-loss benefits. Inside, you'll find:<br/><br/> • 250+ easy, healthful recipes with nutrition information<br/> • 50+ beautiful full-color photos<br/> • Features, tips, and sidebars that provide helpful hints on food shopping, prepping ingredients, and speeding up cooking times
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vegetarian Times
      </h2>
      
      <p class="authorDescription body article">VEGETARIAN TIMES magazine, hailed as "the bible of vegetarianism" by Newsweek, was founded in 1974 and has more than a million readers worldwide. Vegetarian Times is trusted by the New York Times, Time, and CNN as their authority on vegetarian issues.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wiley Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?497414fb